import { devices_config } from '@devices/index';
import { xc_get_chaninfo_from_devinfo } from '@Shelly/xcspec';
//Types
import type { DeviceInfoG2 } from 'src/types/DeviceInfoG2';
import type { TemplateDeviceInfo } from 'src/types/VirtualComponents';
import type { XMODCategoryMode, XMODComponentType } from 'src/types/xmod';

export const mapComponentToCategoryAndMode = (componentType: XMODComponentType): XMODCategoryMode => {
	switch (componentType) {
		case 'cct':
			return { category: 'light', mode: 'cct' };
		case 'rgb':
			return { category: 'light', mode: 'rgb' };
		case 'rgbw':
			return { category: 'light', mode: 'rgbw' };
		case 'light':
			return { category: 'light', mode: 'light' };
		case 'switch':
			return { category: 'relay', mode: 'relay' };
		case 'input':
			return { category: 'inputs_reader', mode: 'inputs_reader' };
		default:
			return { category: 'module', mode: 'module' };
	}
};

export const getXT1Services = (info: DeviceInfoG2, model = 'S3XT-0S'): TemplateDeviceInfo[] => {
	const channels: TemplateDeviceInfo[] = [];
	const chanInfo =
		xc_get_chaninfo_from_devinfo(info)?.chan_list || info?.ch || ([] as DeviceInfoG2['ch'][]);
	chanInfo.forEach((item) => {
		const component = item?.key || '';
		const serviceType = item?.type || '';
		const componentType = component.split(':')[0];
		const componentMode = serviceType ? null : mapComponentToCategoryAndMode(componentType);
		const image = devices_config?.[model]?.modes?.[serviceType] ? serviceType : item?.image || model;
		channels.push({
			component,
			type: serviceType,
			mode: componentMode?.mode || serviceType,
			name: devices_config?.[model]?.modes?.[serviceType]?.name || serviceType || component,
			category:
				devices_config?.[model]?.modes?.[serviceType]?.category ||
				componentMode?.category ||
				serviceType.split(':')[0] ||
				'module',
			image: `images/device_images/${image}.png`,
		});
	});
	return channels;
};
